const API = {
  sendEmail: (domainName, payload, handler) => {
    let headers = {
      Accept: "application/json",
      "Content-Type": "application/json"
    };

    return fetch(`api/v1/domains/${domainName}/emails`, {
      headers: headers,
      method: "POST",
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          res
            .json()
            .then(json => {
              if (json.error && json.error.message) {
                handler({ error: json.error.message });
              } else {
                handler({ error: res.statusText });
              }
            })
            .catch(error => {
              handler({ error: res.statusText });
            });
          return;
        }
        handler({});
      })
      .catch(err => {
        handler({ error: err.message });
      });
  }
};

export default API;



// WEBPACK FOOTER //
// ./src/api/client.js